<ce-level-menu-base>
    <button [class.CeLevelMenuItem--selected]="isProfileActive()" [ce-popover-trigger-for]="profileMenu" (popoverOpened)="profileRef($event)" ce-popover-position="right">
        <ce-name-display [name]="userName()" [displayProfileIcon]="true" class="CeLevelMenuItem-label">
            <ce-icon svgIcon="cog" />
        </ce-name-display>
    </button>
</ce-level-menu-base>

<ce-popover-overlay #profileMenu="cePopoverOverlay">
    <ce-popover class="u-spacing-sm-pv u-size-7xl-w">
        <ce-list size="sm">
            @if (hasProfileSettingsAccess()) {
                <a [routerLink]="['/profile-settings']" (click)="closeProfile()" class="u-color-text-primary u-text-decoration-none">
                    <ce-list-option>
                        <span ce-list-option-title>Profile settings</span>
                    </ce-list-option>
                </a>
            }
            <a [routerLink]="['/auth/logout']" (click)="closeProfile()" class="u-color-text-primary u-text-decoration-none">
                <ce-list-option>
                    <span ce-list-option-title>Logout</span>
                </ce-list-option>
            </a>
        </ce-list>
    </ce-popover>
</ce-popover-overlay>
